﻿
angular.module("controllers", []);
angular.module("repositories", []);
angular.module("services", []);
angular.module("directives", []);
